import axios from "axios";
import {API_DOMAIN} from "../constants";

export async function getRecommendHeaderAdminPortal(fittingId) {
    const response = await axios({
        url: API_DOMAIN + "/api/v2/recommendHeader/adminPortal",
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        params: {
            fittingId,
        },
    });

    return response.data;
}
